/**
 * マスタ情報データクラス
 * */
export class masterInfo {

	// ハガキマスタ情報
	public hagakiMasterInfo: hagakiMasterInfo[];

}

export class hagakiMasterInfo {

	// ハガキ区分
	public id: string

	// ハガキ名称
	public name: string;

	// url
	public url: string;

	// シーケンス
	public seq: number;
}